import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";


export default function RequirePermission({
    permission,
    children
}) {

    const {
        user,
        loading,
        hasPermission
    } = useAuth();


    /*
    =========================================
    WAIT FOR /auth/me
    =========================================
    */

    if (loading) {

        return (
            <div style={loadingPage}>
                Loading...
            </div>
        );

    }


    /*
    =========================================
    NOT LOGGED IN
    =========================================
    */

    if (!user) {

        return (
            <Navigate
                to="/login"
                replace
            />
        );

    }


    /*
    =========================================
    NOT ADMIN
    =========================================
    */

    if (user.role !== "admin") {

        return (
            <Navigate
                to="/"
                replace
            />
        );

    }


    /*
    =========================================
    HAS REQUIRED PERMISSION
    =========================================
    */

    if (hasPermission(permission)) {

        return children;

    }


    /*
    =========================================
    DOES NOT HAVE REQUIRED PERMISSION

    Send admin to first page they ARE
    allowed to access.
    =========================================
    */

    if (hasPermission("view_dashboard")) {

        return (
            <Navigate
                to="/admin/dashboard"
                replace
            />
        );

    }


    if (hasPermission("manage_tours")) {

        return (
            <Navigate
                to="/admin/tours"
                replace
            />
        );

    }


    if (hasPermission("manage_bookings")) {

        return (
            <Navigate
                to="/admin/bookings"
                replace
            />
        );

    }


    if (hasPermission("manage_email")) {

        return (
            <Navigate
                to="/admin/email"
                replace
            />
        );

    }


    if (hasPermission("manage_guides")) {

        return (
            <Navigate
                to="/admin/guides"
                replace
            />
        );

    }


    if (hasPermission("manage_availability")) {

        return (
            <Navigate
                to="/admin/guide-availability"
                replace
            />
        );

    }


    if (hasPermission("manage_users")) {

        return (
            <Navigate
                to="/admin/users"
                replace
            />
        );

    }


    /*
    =========================================
    ADMIN HAS NO PAGE PERMISSIONS
    =========================================
    */

    return (

        <div style={deniedPage}>

            <div style={deniedCard}>

                <div style={icon}>
                    🔒
                </div>

                <h2>
                    Access restricted
                </h2>

                <p>
                    Your account currently has no
                    administrative permissions.
                </p>

            </div>

        </div>

    );

}


/*
=========================================
STYLES
=========================================
*/

const loadingPage = {
    padding: 40
};


const deniedPage = {
    minHeight: "100vh",
    background: "#f8fafc",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20
};


const deniedCard = {
    background: "white",
    padding: 40,
    borderRadius: 14,
    maxWidth: 500,
    textAlign: "center",
    boxShadow:
        "0 4px 18px rgba(0,0,0,0.06)"
};


const icon = {
    fontSize: 40,
    marginBottom: 15
};